// Vendors
var imagesLoaded = require('imagesloaded');

class Images {

    /**
     * @since 0.2.0
     * @method constructor
     */
    constructor() {
        // Create the images loaded plugin
        imagesLoaded.makeJQueryPlugin($);

        // Run lazy loading features
        this.lazyLoaded();
    }

    /**
     * Fade in images when they are finished loading.
     *
     * @since 0.3.0
     * @method lazyLoaded
     * @return void
     */
    lazyLoaded() {
        // Declare and initialize
        let items = $('img[loading="lazy"], img[fetchpriority="high"]');

        // If we got none, we done
        if (!items.length)
            return;

        // Go through them
        items.each((i, ele) => {

            // Keep our context clear
            let image = $(ele);

            // Wait for them to finish loading
            image.imagesLoaded((instance) => {

                // Add in the new class
                image.addClass('loaded');

                // If we want to convert to background, do so now
                if (image.hasClass('to-bg'))
                    setTimeout(() => this.toBackground(image), 2000);

            });

        });
    }

    /**
     * Convert an image to a background image setting.
     *
     * @since 0.3.0
     * @method toCSSBackground
     * @param object img is the image element to process
     * @return void
     */
    toBackground(img) {
        // Declare and initialize
        let srcSet     = img.attr('srcset');
        let src        = img.attr('src');
        let imageSet   = 'url("' + src + '") 1x';
        let densityMap = [
            {width: 300, density: '0.5x'},
            {width: 600, density: '1x'},
            {width: 768, density: '1.5x'},
            {width: 1024, density: '2x'},
            {width: 1536, density: '3x'},
            {width: Infinity, density: '4x'}
        ];

        // Parse the srcset attribute
        if (srcSet) {

            // Split up all the sources
            let sources = srcSet.split(',').map(item => item.trim());

            // Compound our new set string
            sources.forEach(source => {

                // Set up the URL and descriptor for image sets
                let [url, descriptor] = source.split(' ');

                // Grab the density descriptor
                let density = descriptor;

                // Only run if we are in the pixel width format
                if (descriptor.endsWith('w')) {

                    // Search through our density map
                    density = densityMap.find(
                        ({width}) => (parseInt(descriptor, 10) <= width)
                    ).density;

                }

                // Compound the value
                imageSet += ', url("' + url + '") ' + density;

            });

        }

        // Apply image-set as background-image to the parent container
        img.addClass('set-to-bg').parent().addClass('to-bg').css({
            'background-image':    'image-set(' + imageSet + ')',
            'background-size':     'cover',
            'background-position': 'center'
        });

        // Hide the original image if needed
        setTimeout(() => img.hide(), 1000);
    }
}

export default Images;